<template>
  <div>
    <el-dialog
      custom-class="picture-dialog"
      title="本地素材库"
      :visible="isOpen"
      :append-to-body="true"
      :before-close="cancel"
      top="10vh"
    >
      <el-tabs v-model="material_active_name" @tab-click="tabsChange">
        <el-tab-pane label="素材库" name="material_lib">
          <material-box-list
            v-if="material_active_name === 'material_lib'"
            ref="material_box_list_ref"
            :advertiser="advertiser"
            :add-view="addView"
            :restriction="materialRestriction"
            :thumb-material-list="select_file_arr"
            :loacl-material="loaclMaterial"
            :material-format-id="materialFormatId"
            :game-id="gameId"
            :is-support-switch-img-type="isSupportSwitchImgType"
            @select-material="selectMaterial"
            @select-all-material="selectAllMaterial"
          />
        </el-tab-pane>
        <el-tab-pane label="上传素材" name="upload_material">
          <material-box-upload
            v-if="material_active_name === 'upload_material'"
            ref="material_box_upload"
            :add-view="addView"
            :restriction="materialRestriction"
            :material-format-id="materialFormatId"
            :is-support-switch-img-type="isSupportSwitchImgType"
            @select-file="selectFile"
            @save-file="saveFile"
          />
        </el-tab-pane>
        <el-tab-pane v-if="tempMaterial" label="智能截图" name="cut_pic">
          <div v-loading="!cut_pic_list.length" class="show_picture">
            <show-picture
              v-if="cut_pic_list.length"
              :pic-list="cut_pic_list"
              @checked="checkedPic"
            />
          </div>
        </el-tab-pane>
      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <span class="f-left">已选择 {{ select_file_arr.length }}/200</span>
        <div class="thumb-img">
          <div
            v-for="(file_item, file_index) in select_file_arr"
            :key="file_index"
            class="item"
          >
            <el-image
              v-for="(item, index) in file_item.url"
              :key="index"
              :style="{
                float: 'left',
                position: 'relative',
                width: (file_item.url.length > 1 ? 33.33 : 100) + '%',
                height: (file_item.url.length > 1 ? 50 : 100) + '%'
              }"
              :fit="file_item.url.length > 1 ? 'cover' : 'contain'"
              :src="item.thumb_url ? item.thumb_url : item.url"
            />
            <i class="el-icon-error" @click="removeMaterial(file_item)" />
          </div>
        </div>
        <el-button @click="cancel">取 消</el-button>
        <el-button :loading="is_submit" type="primary" @click="submitRes">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { unique } from '@/utils';

import MaterialResource from '@/api/material';
const materialResource = new MaterialResource();

export default {
  components: {
    'material-box-list': () => import('./components/material-box-list'),
    'material-box-upload': () => import('./components/material-box-upload'),
    'show-picture': () => import('@/components/show-picture'),
  },
  props: {
    /**
     * 平台
     */
    advertiser: {
      type: String,
      default: '',
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    isRadio: {
      type: Boolean,
      default: false,
    },
    loaclMaterial: {
      type: Array,
      default: () => {
        return null;
      },
    },
    tempMaterial: {
      type: Object,
      default: () => {
        return {};
      },
    },
    adBasicConfig: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 素材规格id
    materialFormatId: {
      type: [String, Number],
      default: '',
    },
    /** 素材限制 - 支持多个限制条件 */
    materialRestriction: {
      type: Array,
      default: () => {
        return [];
      },
    },
    /** 游戏ID */
    gameId: {
      type: Number,
      default: null,
    },
    /**
     * 是否支持切换图片类型
     * - 单图[image - 1]
     * - 组图[element_story - 4]
     */
    isSupportSwitchImgType: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      material_active_name: 'material_lib', // 素材标签页
      select_file_arr: [], // 临时文件数组
      is_submit: false, // 是否提交
      cut_pic_list: [], // 智能截图数组
      restriction: {
        width: '',
        height: '',
        file_size: '',
      },
      video_id: '',
      addView: {
        file_type: 'image',
        is_radio: false,
        params: {
          thumb_width: 1280,
          thumb_height: 720,
          getAdvertiserId: () => {
            const data_arr = this.adBasicConfig.advertiser_ids;
            const new_arr = data_arr.map((item) => {
              return item.value;
            });
            return new_arr;
          },
        },
      },
    };
  },
  created() {
    // 如果有素材规则传入
    if (this.tempMaterial){
      this.restriction = {
        width: this.tempMaterial.width,
        height: this.tempMaterial.height,
        file_size: this.tempMaterial.size,
      };
      this.video_id = this.tempMaterial.id;
      this.material_active_name = 'cut_pic';
      this.getCutPic();
    }
    this.addView.file_type = this.type;
    this.addView.is_radio = this.isRadio;
  },
  methods: {
    // 标签栏切换
    tabsChange() {
      this.select_file_arr = [];
      // 如果点击智能截图
      if (this.material_active_name === 'cut_pic'){
        this.getCutPic();
      }
    },
    // 选中文件
    selectFile(temp_file_arr) {
      if (!temp_file_arr) {
        this.cancel();
        return;
      }
      this.select_file_arr = temp_file_arr;

      this.saveFile();
    },
    // 选择素材
    selectMaterial(material_item) {
      if (this.isRadio) {
        this.select_file_arr = [];
      }
      if (!material_item.selected) {
        this.removeSelectedMaterial(this.select_file_arr, material_item);
      } else {
        this.select_file_arr.push(material_item);
      }
    },
    /**
     * 全选素材
     * @param {Object[]} material_list 当前页素材
     * @returns {void}
     */
    selectAllMaterial(material_list) {
      material_list.forEach(material_item => {
        this.selectMaterial(material_item);
      });
      this.$set(this, 'select_file_arr', unique(this.select_file_arr, 'id'));
    },
    // 移除素材
    removeMaterial(material_item) {
      this.removeSelectedMaterial(this.select_file_arr, material_item);
      this.syncMaterialSelection(material_item, false);
    },
    // 保存文件
    saveFile() {
      if (this.select_file_arr.length <= 0) {
        this.cancel();
        return;
      }
      this.$emit('confirm', this.select_file_arr, this.type);
    },

    // 获取智能截图
    getCutPic(){
      const params = {
        local_material_id: this.video_id,
        width: this.restriction.width,
        height: this.restriction.height,
        size: this.restriction.file_size,
      };
      return new Promise((resolve, reject) => {
        materialResource
          .getVideoCutPic(params)
          .then((response) => {
            this.cut_pic_list = response;
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    /**
      * 选中智能截图后
      * @param list 智能截图组件传过来的选中数据
    */
    checkedPic(list){
      this.select_file_arr = [];
      // 格式化选中截图数据
      list.forEach(item => {
        const obj = {
          selected: true,
          url: [
            { thumb_url: item, url: item },
          ],
        };
        this.selectMaterial(obj);
      });
    },

    // 取消
    cancel() {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.$emit('cancel', false);
        })
        .catch(_ => {});
    },
    // 提交资源
    submitRes() {
      this.is_submit = true;
      // 标签页选择上传标签页执行上传操作，否则保存素材
      if (this.material_active_name === 'upload_material') {
        this.$refs.material_box_upload.submitUpload(true);
      } else {
        this.saveFile();
      }
    },
    /**
     * 同步素材列表的选中状态
     * @param {Object} material_item 要同步的素材
     * @param {boolean} selected 选中状态
     * @returns {void}
     */
    syncMaterialSelection(material_item, selected) {
      const ref = this.$refs.material_box_list_ref;
      const material_list = ref.material_list;
      const index = material_list.findIndex(material => material.id === material_item.id);
      if (index > -1) {
        material_list[index].selected = selected;
      }
      ref?.handleCheckAllStatus?.();
    },
    /**
     * 移除选中的素材
     * @param {Array<Object>} sources 选中的素材列表
     * @param {Object} material 被移除的素材
     * @returns {void}
     */
    removeSelectedMaterial(sources, material) {
      const index = sources.findIndex(source => source.id === material.id);
      if (index > -1) {
        sources.splice(index, 1);
      }
    },
  },
};
</script>

<style scoped rel="stylesheet/scss" lang="scss">
/deep/ .picture-dialog {
  width: auto;
  min-width: 1010px;
  max-width: 1065px;
  .material-container {
    .material-cord {
      min-height: 286px;
      position: relative;
      .constituency {
        overflow-y: scroll;
        height: 400px;
        width: 100%;
        ul {
          margin: 0;
          padding: 0;
          li {
            position: relative;
            list-style: none;
            border: 0;
            width: 245px;
            margin-top: 16px;
            margin-right: 12px;
            display: inline-block;
            background-color: #ccc;
            .item .img-show img {
              max-width: 100%;
              max-height: 100%;
            }
          }
          li:nth-child(4n) {
            margin-right: 0;
          }
        }
      }
    }
  }
  .f-left {
    float: left;
  }
  .f-right {
    float: right;
  }
  .label-border {
    width: 140px;
    height: 32px;
    line-height: 32px;
    border-radius: 4px;
    text-align: center;
    border: 1px #dcdee2 solid;
  }
  .el-upload {
    width: 100%;
  }
  .el-upload-dragger {
    width: 100%;
  }
  .el-dialog__footer {
    border-top: 1px #d9d9d9 solid;
    padding: 15px 20px;
  }
  .dialog-footer {
    height: 54px;
    line-height: 54px;
    .thumb-img {
      float: left;
      width: 690px;
      height: 65px;
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;
      margin-left: 50px;
      text-align: left;
      padding-top: 5px;
      .item {
        position: relative;
        width: 95px;
        height: 54px;
        display: inline-block;
        text-align: center;
        border: 1px #aaa solid;
        margin: 0 10px;
        i {
          position: absolute;
          top: -6px;
          right: -6px;
          font-size: 20px;
          color: #999;
          cursor: pointer;
          background-color: #fff;
          border-radius: 50%;
          &:hover {
            color: red;
          }
        }
      }
    }
  }
}
.show_picture{
  width: 100%;
  height: 385px;
}
</style>
